export default "__VITE_PUBLIC_ASSET__51784123__"